import { render, staticRenderFns } from "./PaymentTypes.vue?vue&type=template&id=64e4a8fc&scoped=true&"
import script from "./PaymentTypes.vue?vue&type=script&lang=ts&"
export * from "./PaymentTypes.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentTypes.vue?vue&type=style&index=0&id=64e4a8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4a8fc",
  null
  
)

export default component.exports